import { Lesson } from '../../../../types';

const lesson: Lesson = {
  itemId: '2084096',
  title: 'Como serão as aulas gravadas e ao vivo',
  video: { platform: 'youtube', videoId: 'iu5EOMwFdho' },
  article: ['Descrição da aula.'],
};
export default lesson;

